import { useEffect, useRef } from 'react';
import { modeIds } from '../engine/registry';
import { ACHIEVEMENTS, unlockedIds } from '../state/achievements';
import { loadSlice, saveSlice, type SliceConfig } from '../state/persistence';
import { useStats } from '../state/StatsContext';
import { useToast } from './Toast';

export const seenSlice: SliceConfig<string[]> = {
  name: 'achievements-seen',
  version: 1,
  defaults: () => [],
};

/**
 * Watches stats and toasts newly-unlocked achievements. The first run after load
 * silently baselines whatever is already unlocked, so historical achievements
 * don't all fire at once.
 */
export function AchievementWatcher() {
  const { stats } = useStats();
  const toast = useToast();
  const baselined = useRef(false);

  useEffect(() => {
    const ids = modeIds();
    const seen = new Set(loadSlice(seenSlice));
    const unlocked = unlockedIds(stats, ids, seen);

    if (!baselined.current) {
      baselined.current = true;
      saveSlice(seenSlice, [...new Set([...seen, ...unlocked])]);
      return;
    }

    const fresh = [...unlocked].filter((id) => !seen.has(id));
    if (fresh.length > 0) {
      for (const id of fresh) {
        const a = ACHIEVEMENTS.find((x) => x.id === id);
        if (a) toast.show(`🏆 ${a.name} unlocked!`, 'success');
      }
      saveSlice(seenSlice, [...new Set([...seen, ...unlocked])]);
    }
  }, [stats, toast]);

  return null;
}
